import { render, staticRenderFns } from "./BaseFilesUploadButton.vue?vue&type=template&id=2424d8dc&scoped=true&"
import script from "./BaseFilesUploadButton.vue?vue&type=script&lang=js&"
export * from "./BaseFilesUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilesUploadButton.vue?vue&type=style&index=0&id=2424d8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424d8dc",
  null
  
)

export default component.exports